import { type } from "os";

export interface Vertical {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const VerticalSchema = {
  name: 'Vertical',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' },
    company: { type: 'string' },
    short_code: { type: 'string' }
  }
};
